export function buildPatientName (patient) {
  return `${patient.firstName} ${patient.middleName || ''} ${patient.lastName}`
}

export function buildPatientLastName (patient) {
  let name = `${patient.lastName},${patient.firstName}`
  if (patient.middleName) {
    name += ' ' + patient.middleName
  }
  return name.toUpperCase()
}

export const buildPatientIdentifer = (identifiers, type) => {
  const foundIdentifier = identifiers.find((id) => {
    if (id.type) {
      return id.type.text === type
    }
    return null
  })
  return foundIdentifier ? foundIdentifier.value : ''
}
